import { Component } from '@angular/core';
import { PmIconComponent } from '@libs/ui';
import { TranslateModule } from '@ngx-translate/core';
import { LucideLock } from '@lucide/angular';

@Component({
  selector: 'pm-access-denied-page',
  templateUrl: './access-denied-page.component.html',
  imports: [TranslateModule, PmIconComponent],
})
export class AccessDeniedPageComponent {
  lock = LucideLock;
}
